import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { StatusAcceptanceType } from '../../store/constants';
import { Tracking } from '../../store/models';
import {
  IconColor,
  IconSize,
  IconType,
  S_CODE_ICONS,
  SHORT_DISPLAY_DATE_FORMAT,
  DISPLAY_DATE_FORMAT,
  SCode,
  IconNames,
} from '../../common/constants';

@Component({
  selector: 'ui-delivery-status-tracking-status',
  templateUrl: './delivery-status-tracking-status.component.html',
  styleUrls: ['./delivery-status-tracking-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeliveryStatusTrackingStatusComponent {
  @Input() statuses: Tracking[];
  @Input() isTimezoneAvailable = false;

  iconType = IconType;
  iconSize = IconSize;
  iconColor = IconColor;
  sCodeIcons: Map<SCode, IconNames> = S_CODE_ICONS;
  shortDateFormat = SHORT_DISPLAY_DATE_FORMAT;
  dateFormat = DISPLAY_DATE_FORMAT;
  acceptanceType = StatusAcceptanceType;
}
